import { RevealLines, Reveal } from "@/components/Reveal";

const clauses = [
  { n: "01", t: "15-Day Window", d: "You may request a refund within 15 days of the delivery date. After 15 days, we're unable to process a return." },
  { n: "02", t: "Condition", d: "Items must be unworn, unwashed, and returned with original tags and packaging intact." },
  { n: "03", t: "How to Request", d: "Write to us at care@anhadcollections.com or use the Customer Service page with your order number. We arrange a pickup." },
  { n: "04", t: "Refund Timeline", d: "Once the item is received and inspected, your refund is processed to the original payment method within 5–7 business days via Razorpay." },
  { n: "05", t: "Exceptions", d: "Customised or made-to-order pieces and items marked final sale are not eligible for refund unless they arrive damaged." },
];

const Refund = () => (
  <div className="max-w-4xl mx-auto px-6 md:px-10 pt-20 md:pt-28 pb-24">
    <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8C3A3A] mb-5">Care</p>
    <h1 className="font-serif font-light text-6xl md:text-8xl tracking-tight text-[#1A1A1A] leading-[0.9]">
      <RevealLines lines={["Refund", "Policy"]} />
    </h1>
    <Reveal delay={0.2}>
      <p className="font-sans text-[15px] text-[#595959] leading-relaxed mt-8 max-w-2xl">
        We want you to love what you wear. If something isn't right, our 15-day refund policy makes returns simple and fair.
      </p>
    </Reveal>
    <div className="mt-16 divide-y divide-[#E5E1D8] border-t border-[#E5E1D8]">
      {clauses.map((c, i) => (
        <Reveal key={c.n} delay={i * 0.05}>
          <div className="grid md:grid-cols-12 gap-4 py-9" data-testid={`refund-clause-${c.n}`}>
            <p className="md:col-span-2 font-mono text-sm text-[#8C3A3A]">{c.n}</p>
            <h3 className="md:col-span-4 font-serif text-2xl text-[#1A1A1A]">{c.t}</h3>
            <p className="md:col-span-6 font-sans text-sm text-[#595959] leading-relaxed">{c.d}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </div>
);

export default Refund;
